import React, { useEffect, useState } from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import S from './ListDam.module.css'
import D from '../images/cow.svg'

import { useGlobalContext } from '../Components/Context';
import EditModalDam from '../Components/AdDnewCattle';

import Hoc from '../Components/HOCcattles/Hoc';
import { showUserExtra } from '../api/helper';



export default function ListDam() {
  const {openModalls,isOpenModal}=useGlobalContext();
  return (
    <div className={S.AllAnimalssLICon}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',width:'100%'}}>
      <div className={S.AllAnimalssTitleLICon}>
        <img className={S.AllAnimalssIconimgLITit} src={D}/>
        <h2>دام ها</h2>
        </div>
        {showUserExtra&&<div style={{display:'flex', gap:'10px',alignItems:'center'}}>
        <div onClick={()=>{openModalls()}} data-title='افزودن دام جدید' className={`${S.EditBtnTableDam}`}>
               <AddCircleOutlineIcon sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }}/>  
        </div>
        
        
        </div>}
           
      </div>
        <hr/>
        <Hoc flag={'cattle'} id=''/>

        {isOpenModal&&<EditModalDam flag={'add'}/>}
    </div>
  );
}